/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import style from './TicketCreate.module.scss';
import { uploadFiles } from '../../api';
import useAlert from '../../hooks/useAlert';
import { CheckingValidComment } from '../../lib/common';
import AttachmentsView from './AttachmentsView';

const SubComplaintType = ({
  subComplaintsData,
  issueComment,
  setIssueComment,
  fileData,
  deleteImage,
  handleFileUpload,
  selectedNotModifyTypeArr,
  setSelectedNotModifyTypeArr,
  setEnableSubComplaintBtn,
  modifyDataObj,
  setModifyDataObj,
}) => {
  const [subComplaintArr, setSubComplaintArr] = useState([]);
  const [isSelected, setIsSelected] = useState(true);
  const modalRef = useRef();
  const inputRef = useRef();
  const iconRef = useRef(null);
  const [, setLoading] = useState(false);
  const [setAlert] = useAlert();
  const [expandedSections, setExpandedSections] = useState({});

  const toggleSection = (key) => {
    setExpandedSections((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const modifyData = {
    'CALL BUTTON COLOUR': {
      heading: 'Banner call button',
      options: ['Call button color'],
      attachments: [],
      comment: '',
      selectedOption: 'Call button color',
    },
    'BANNER COLOUR': {
      heading: 'Banner color',
      options: ['Change background color'],
      attachments: [],
      comment: '',
      selectedOption: 'Change background color',
    },
    'CHANGE TYPOGRAPHY': {
      heading: 'Change text style',
      options: ['Name in uppercase', 'Capitalize case', 'Lower case', 'Sentence case'],
      attachments: [],
      comment: '',
      selectedOption: '',
    },
  };

  const handleModifyFileUpload = async (event, modifyKey) => {
    const file = event.target.files[0];
    const sizeInKB = (file.size / 1024).toFixed(2);
    if (file && file.type.startsWith('image/')) {
      setLoading(true);
      if (file && file.size > 2 * 1024 * 1024) {
        setAlert({
          message: 'File size should not exceed 2 MB',
          status: false,
        });
      } else {
        const files = event.target.files ? [...event.target.files] : [];
        try {
          const response = await uploadFiles(files, true);
          if (response.error_code === 0) {
            setLoading(false);
            if (response.image_urls && response.image_urls.length > 0) {
              setModifyDataObj((prev) => ({
                ...prev,
                [modifyKey]: {
                  ...prev[modifyKey],
                  attachments: [
                    ...prev[modifyKey].attachments,
                    {
                      name: `${modifyKey}: ${files?.[0]?.name}`,
                      url: response?.image_urls?.[0],
                      size: `${sizeInKB} Kb`,
                    },
                  ],
                },
              }));
            }
          } else {
            setAlert({
              message: response?.msg || 'Accepts only image file',
              status: false,
            });
          }
        } catch (err) {
          console.log('Error: ', err);
        }
      }
      setLoading(false);
    } else {
      setAlert({
        message: 'Accepts only image file',
        status: false,
      });
    }
  };

  const clickOutsideModal = (e) => {
    if (
      modalRef.current &&
      !modalRef.current.contains(e.target) &&
      inputRef.current &&
      !inputRef.current.contains(e.target) &&
      iconRef.current &&
      !iconRef.current.contains(e.target)
    ) {
      setIsSelected(false);
    }
  };
  useEffect(() => {
    document.addEventListener('mousedown', clickOutsideModal);
    return () => document.removeEventListener('mousedown', clickOutsideModal);
  }, [isSelected]);

  const modifyKeysArr = Object.keys(modifyData);

  const handleSelectSubComplaint = (val) => {
    if (modifyKeysArr.includes(val)) {
      const existingKeysArr = Object.keys(modifyDataObj);
      if (existingKeysArr.includes(val)) {
        const updtObj = { ...modifyDataObj };
        delete updtObj[val];
        setModifyDataObj(updtObj);
        setExpandedSections((prev) => ({
          ...prev,
          [val]: false,
        }));
      } else {
        setModifyDataObj({ ...modifyDataObj, [val]: modifyData[val] });
        setExpandedSections((prev) => ({
          ...prev,
          [val]: !prev[val],
        }));
      }
    } else {
      setSelectedNotModifyTypeArr((prev) => {
        if (prev.includes(val)) {
          return prev.filter((item) => item !== val);
        }
        return [...prev, val];
      });
      setExpandedSections((prev) => ({
        ...prev,
        notModifyType: !prev[val],
      }));
    }
    setSubComplaintArr((prev) => (prev.includes(val) ? prev.filter((item) => item !== val) : [...prev, val]));
  };

  const handleUpdateModifyObj = (modifyKey, value, updateKey) => {
    setModifyDataObj((prev) => ({
      ...prev,
      [modifyKey]: {
        ...prev[modifyKey],
        [updateKey]: value,
      },
    }));
  };

  const handleDeleteAttachment = (modifyKey, fileIndex) => {
    const updatedAttachments = modifyDataObj[modifyKey].attachments.filter((_, i) => i !== fileIndex);
    setModifyDataObj((prev) => ({
      ...prev,
      [modifyKey]: {
        ...prev[modifyKey],
        attachments: updatedAttachments,
      },
    }));
  };

  useEffect(() => {
    if (modifyDataObj && Object.keys(modifyDataObj)?.length > 0) {
      const isEnableBtn = Object.values(modifyDataObj).every((item) => {
        const commentIsValid = item.comment === '' || CheckingValidComment(item.comment);
        const selectedOption = !!item.selectedOption;

        return commentIsValid && (selectedOption || item.comment);
      });

      setEnableSubComplaintBtn(isEnableBtn);
    }
  }, [modifyDataObj]);

  const handleNotModifyCommentChange = (keyVal, commentVal) => {
    setIssueComment(commentVal);
  };

  const handleNotModifyDeleteAttachment = (keyVal, idx) => {
    deleteImage(idx);
  };

  const isBtnDisable = !subComplaintArr || subComplaintArr?.length === 0;

  const capitalizedText = selectedNotModifyTypeArr
    ?.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(', ');

  return (
    <>
      <div>
        <div className={`${style.FormGroupBox} form_group_box mt-20`}>
          <div className="form_group">
            <input
              ref={inputRef}
              className={`${style.Input} input font13 fw500 color111 pl-15 pr-45`}
              type="text"
              required
              defaultValue="Select Status"
              value={subComplaintArr?.join(', ')}
              onClick={() => setIsSelected((prev) => !prev)}
              readOnly
            />
            <div
              ref={iconRef}
              onClick={(e) => {
                e.stopPropagation();
                setIsSelected((prev) => !prev);
              }}
              role="presentation"
              style={{ cursor: 'pointer' }}
            >
              <span
                style={{
                  transform: isSelected ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: '0.3s all',
                }}
                className={`${style.SelectArrow} select_arrow input_icon icon`}
              />
              <span className="inputbar" />
              <span className={`${style.AddOne} font12 fw500 colorFFF`}>{subComplaintArr?.length || 0}</span>
            </div>
            <div
              style={{
                top: '-10px',
                left: '6px',
              }}
              className={`${style.InputLabel} input_label font12 fw500 color777`}
            >
              Sub Complaint Type<span className="colorEB5">*</span>
            </div>
            <div
              ref={modalRef}
              className={`${style.InputDropdown} input__dropdown`}
              style={{ display: isSelected ? 'block' : 'none' }}
            >
              <ul className={`${style.InputDroplist} input__droplist`}>
                {subComplaintsData?.map((item, idx) => (
                  <li
                    role="presentation"
                    className="input__dropitem"
                    key={idx}
                    onClick={() => handleSelectSubComplaint(item)}
                    onMouseDown={(e) => {
                      e.stopPropagation();
                      handleSelectSubComplaint(item);
                    }}
                  >
                    <label htmlFor={`subComplaint_${idx}`} className={`${style.Radio__Lable} whitefill_animate`}>
                      <input
                        id={`subComplaint_${idx}`}
                        className={`${style.Radio__Input} `}
                        type="checkbox"
                        name="sidcity_radio"
                        checked={subComplaintArr?.includes(item)}
                        readOnly
                      />
                      <div className={`${style.Radio__Icon} csicon `} />
                      <div className={` ${style.Radio__Text} font14 fw500 color111`}>{item}</div>
                    </label>
                  </li>
                ))}
              </ul>
              <div className={`${style.ButtonGroup} `}>
                <button
                  disabled={isBtnDisable}
                  onClick={() => {
                    setSubComplaintArr([]);
                    setModifyDataObj({});
                    setSelectedNotModifyTypeArr([]);
                  }}
                  type="button"
                  className={`${style.Button} blue_whitefill_animate `}
                >
                  <span className={`${style.ButtonText} font13 fw500 color007`}>Clear All</span>
                </button>
                <button
                  disabled={isBtnDisable}
                  onClick={() => setIsSelected(false)}
                  type="button"
                  className={`${style.Button} bluefill_animate `}
                >
                  <span className={`${style.ButtonText} font13 fw500 colorFFF`}>Add</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        {modifyDataObj && Object.keys(modifyDataObj)?.length > 0 && (
          <>
            {Object.entries(modifyDataObj).map(([key, value]) => (
              <div className={`${style.Summary} ${style.Summary__Active} mt-20`} key={key}>
                <div onClick={() => toggleSection(key)} role="presentation" className={`${style.Summary__Pannel}`}>
                  <div className={`${style.Summary__title} font16 fw600 color111`}>{value.heading}</div>
                  <div
                    className={`${style.Summary__Drop__Icon} csicon`}
                    style={{
                      transform: expandedSections[key] ? 'rotate(180deg)' : 'rotate(0deg)',
                      transition: '0.3s all',
                    }}
                  />
                </div>
                {expandedSections[key] && (
                  <div className={`${style.Summary__Details}`}>
                    <div className="font12 fw500 color777">Select Customization</div>
                    <ul className={`${style.Summary__ItemList}`}>
                      {value.options.map((option, index) => (
                        <li
                          role="presentation"
                          onClick={() => handleUpdateModifyObj(key, option, 'selectedOption')}
                          onMouseDown={(e) => {
                            e.stopPropagation();
                            handleUpdateModifyObj(key, option, 'selectedOption');
                          }}
                          className={`${style.Summary__Item}`}
                          key={index}
                        >
                          <label htmlFor={`modify_option_${index}`} className={`${style.Checkbox__Lable}`}>
                            <input
                              className={`${style.Checkbox__Input} `}
                              type="checkbox"
                              id={`modify_option_${index}`}
                              checked={value.selectedOption === option}
                              readOnly
                            />
                            <span className={`${style.Checkbox__Icon} csicon `} />
                            <span className={` ${style.Checkbox__Text} font14 fw500 color111`}>{option}</span>
                          </label>
                        </li>
                      ))}
                    </ul>
                    <AttachmentsView
                      style={style}
                      attachmentsArr={value?.attachments || []}
                      comment={value?.comment || ''}
                      keyVal={key}
                      handleAddAttachment={handleModifyFileUpload}
                      handleDeleteAttachment={handleDeleteAttachment}
                      handleCommentChange={handleUpdateModifyObj}
                    />
                  </div>
                )}
              </div>
            ))}
          </>
        )}

        {selectedNotModifyTypeArr && selectedNotModifyTypeArr?.length > 0 && (
          <div className={`${style.Summary} ${style.Summary__Active} mt-20`} key="notModifyType">
            <div
              onClick={() => toggleSection('notModifyType')}
              role="presentation"
              className={`${style.Summary__Pannel}`}
            >
              <div className={`${style.Summary__title} font16 fw600 color111 mr-10`}>{capitalizedText}</div>
              <div
                className={`${style.Summary__Drop__Icon} csicon`}
                style={{
                  transform: expandedSections.notModifyType ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: '0.3s all',
                }}
              />
            </div>
            {expandedSections.notModifyType && (
              <div className={`${style.Summary__Details}`}>
                <AttachmentsView
                  style={style}
                  attachmentsArr={fileData || []}
                  comment={issueComment || ''}
                  keyVal="notModifyType"
                  handleAddAttachment={handleFileUpload}
                  handleDeleteAttachment={handleNotModifyDeleteAttachment}
                  handleCommentChange={handleNotModifyCommentChange}
                />
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default SubComplaintType;
SubComplaintType.propTypes = {
  subComplaintsData: PropTypes.array,
  issueComment: PropTypes.string,
  setIssueComment: PropTypes.func,
  fileData: PropTypes.array,
  deleteImage: PropTypes.func,
  handleFileUpload: PropTypes.func,
  selectedNotModifyTypeArr: PropTypes.array,
  setSelectedNotModifyTypeArr: PropTypes.func,
  setEnableSubComplaintBtn: PropTypes.func,
  modifyDataObj: PropTypes.object,
  setModifyDataObj: PropTypes.func,
};
